import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { DateManipulationCheckEffects } from './effects/date-manipulation-check.effects';
import { dateManipulationCheckReducer } from './reducers/date-manipulation-check.reducer';
import { selectPersistedDateManipulationCheckTimestamps } from './selectors/date-manipulation-check.selector';
import { DATE_MANIPULATION_CHECK_FEATURE_KEY } from './date-manipulation-check-collection.state';

/**
 * Registers the date-manipulation-check feature slice. Imported by `apps/pace/src/app/app.module.ts`
 * next to `EscalationStoreModule`, gated by `environment.ngrx?.enableForDateManipulationCheck`.
 *
 * The two timestamps are written through the generic `PERSISTED_SLICES` / `persistSlice` layer,
 * i.e. the cross-device concurrency store — not the legacy service's device-local encrypted
 * `localStorage`. The two backends do not share storage, so the values do not carry across a
 * flag flip: the first boot with the flag on starts from an empty slice, the internal timestamp
 * defaults to *now*, the external timestamp comes from the next `IsaliveSet` response, and the
 * check passes without a spurious app lock. See `docs/date-manipulation-check-ngrx-migration.md`,
 * Decision 1, for the full trade-off.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(DATE_MANIPULATION_CHECK_FEATURE_KEY, dateManipulationCheckReducer),
        EffectsModule.forFeature([DateManipulationCheckEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: DATE_MANIPULATION_CHECK_FEATURE_KEY,
                persistSelector: selectPersistedDateManipulationCheckTimestamps,
            },
        },
    ],
})
export class DateManipulationCheckStoreModule {}
